import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './careers.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import Flippy, { FrontSide, BackSide } from 'react-flippy';
import Data from './data.js';

function CareersWork() {
  const globalClasses = globalUseStyles();
  return (
    <ThemeProvider theme={theme}>
      <Container className={"careersWhy"} maxWidth={false} component="section">
        <Grid className={globalClasses.containerVertPaddingLg} container>
          <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12} lg={12} >
              <Typography variant="subtitle1">Why work at Pantheon?</Typography>
              <Typography variant="h1">Diversity of people, skills and perspectives</Typography>
              <Typography variant="body2">Pantheon is committed to a warm, inclusive workplace that makes everyone feel at home. We bring together cross functional teams of strategists, designers, and technologists to collaborate and innovate towards solutions. We believe that differences of background and opinions lead to the best outcomes, and we celebrate the diversity, equity, and inclusion of our staff and teams. </Typography>
            </Grid>          
          <Grid item md={12} lg={12} container spacing={3} className={globalClasses.textBlockBelow}>
            <Grid item xs={12} md={12} lg={8} >
              <div className={globalClasses.longBox}> 
                <Typography variant="h3">Benefits and Perks </Typography>
                <Typography variant="body2">We are an established company with a startup mentality that influences not just how we conduct projects, but also how we treat our employees! </Typography>
              </div>
            </Grid>
            {Data.map(cards => (
          <Grid item xs={12} md={12} lg={4}  >
              <Flippy
                flipOnHover={false} // default false
                flipOnClick={true} // default false
                flipDirection="horizontal" // horizontal or vertical
                        >
                <FrontSide className={globalClasses.normalBox} >
                <Typography className={globalClasses.noMargin}variant="h4">{cards.title}</Typography>
                </FrontSide>
                <BackSide className={globalClasses.normalBoxBack} >
                  <Typography className={globalClasses.noMargin} variant="body2">{cards.desc}</Typography>
                  </BackSide>
              </Flippy>                     
          </Grid>
          ))}
          </Grid>
        </Grid> 
        </Grid>
      </Container> 
    </ThemeProvider>
  );
};

export default CareersWork;